import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { loadAbilities, pathToPermissionKey } from '../utils/permissions';
import { useAuth } from '../contexts/AuthContext';

const RequirePermission = ({ pathKey, requireAdmin, children }) => {
  const location = useLocation();
  const { user } = useAuth();
  const [allowed, setAllowed] = useState(null);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        if (requireAdmin) {
          const isAdmin = user?.role === 'admin';
          if (mounted) setAllowed(!!isAdmin);
          return;
        }
        const abilities = await loadAbilities();
        const key = pathKey || pathToPermissionKey(location.pathname);
        const ok = !!abilities[key];
        // Boş yetki (geçici API hatası) → bir kez daha dene
        if (!ok && abilities && Object.keys(abilities).length === 0) {
          const retry = await loadAbilities({ force: true });
          if (mounted) setAllowed(!!retry[key]);
          return;
        }
        if (mounted) setAllowed(ok);
      } catch (_) {
        if (mounted) setAllowed(false);
      }
    })();
    return () => { mounted = false; };
  }, [location.pathname, pathKey, requireAdmin, user?.role]);

  if (allowed === null) {
    return (
      <div className="flex items-center justify-center min-h-[40vh] text-sm text-gray-500">
        Sayfa yükleniyor...
      </div>
    );
  }
  if (!allowed) return <Navigate to="/" replace />;
  return children;
};

export default RequirePermission;



